
import { memo } from "react"

const Bar = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M8.99999 6.42855V19.2857M6.42856 17.5714H8.57142M11.5714 9.85713H9.42856M16.7143 5.57141V18.4286M14.1428 8.14284H16.2857M19.2857 14.1428H17.1428"
                stroke="currentColor" strokeLinecap="square"/>
        </svg>
    )
}

export default memo(Bar)